'use strict';

import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import auth from './auth.js';
import tasks from './tasks.js';

const persist = (name, reducer) => persistReducer({
  keyPrefix: `plaid->v1->`,
  key: name,
  storage
}, reducer);

export default combineReducers({
  auth: persist(`auth`, auth),
  tasks: persist(`tasks`, tasks)
});



// WEBPACK FOOTER //
// ./src/reducers/index.js